import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

function Members() {
  const navigate = useNavigate();

  const [members, setMembers] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingMember, setEditingMember] = useState(null);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user.role === "admin";

  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    password: "",
    role: "user",
    grade: "apprenti",
    fonction: "",  
  });

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const res = await API.get("/members");
      setMembers(res.data);
    } catch (err) {
      console.error("Erreur membres:", err);
      alert("Impossible de charger les membres");
    }
  };

  const getMemberId = (member) => {
    return member.id || member.user_id || member.userId || member.member_id;
  };

  const startConversation = async (member) => {
    try {
      const targetUserId = getMemberId(member);

      if (!targetUserId) {
        alert("Utilisateur cible invalide");
        return;
      }

      if (String(targetUserId) === String(user.id)) {
        alert("Tu ne peux pas ouvrir une discussion avec toi-même");
        return;
      }

      const res = await API.post("/conversation", {
        user2: targetUserId,
      });

      const conversationId = res.data.conversationId || res.data.id;

      navigate(`/chat/${conversationId}`, {
        state: { member },
      });
    } catch (err) {
      console.error("Erreur conversation:", err);
      alert(err?.response?.data?.message || "Impossible d’ouvrir la discussion");
    }
  };

  const startCall = (member) => {
    const targetUserId = getMemberId(member);

    if (!targetUserId) {
      alert("Utilisateur cible invalide");
      return;
    }

    if (String(targetUserId) === String(user.id)) {
      alert("Tu ne peux pas t’appeler toi-même");
      return;
    }

    navigate(`/call/${targetUserId}`, {
      state: { member },
    });
  };

  const resetForm = () => {
    setForm({
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      password: "",
      role: "user",
      grade: "apprenti",
      fonction: "",
    });
    setEditingMember(null);
  };

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const openEditModal = (member) => {
    setEditingMember(member);
    setForm({
      firstname: member.firstname || "",
      lastname: member.lastname || "",
      email: member.email || "",
      phone: member.phone || "",
      password: "",
      role: member.role || "user",
      grade: member.grade || "apprenti",
      fonction: member.fonction || "",
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    resetForm();
  };

  const saveMember = async () => {
  try {
    if (!form.firstname || !form.lastname || !form.email) {
      alert("Prénom, nom et email obligatoires");
      return;
    }

    if (!editingMember && !form.password) {
      alert("Mot de passe obligatoire");
      return;
    }

    if (editingMember) {
      await API.put(`/users/${editingMember.id}`, {
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        phone: form.phone,

        role: form.role === "admin" ? "admin" : "user",
        grade: form.grade,
        fonction: form.fonction,

        ...(form.password ? { password: form.password } : {}),
      });
    } else {
      await API.post("/users", {
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        phone: form.phone,
        password: form.password,

        role: form.role === "admin" ? "admin" : "user",
        grade: form.grade,
        fonction: form.fonction,
      });
    }

    closeModal();
    fetchMembers();
  } catch (err) {
    console.error("Erreur sauvegarde:", err);
    alert(err?.response?.data?.message || "Erreur lors de la sauvegarde");
  }
};

  const deleteMember = async (member) => {
    if (!window.confirm(`Supprimer ${member.firstname} ${member.lastname} ?`)) return;

    try {
      await API.delete(`/users/${member.id}`);
      fetchMembers();
    } catch (err) {
      alert(err?.response?.data?.message || "Impossible de supprimer");
    }
  };

  const filteredMembers = members.filter((member) => {
    const txt = `${member.firstname} ${member.lastname} ${member.email} ${member.grade} ${member.fonction || ""}`.toLowerCase();
    return txt.includes(search.toLowerCase());
  });

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>←</button>

        <div style={styles.headerCenter}>
          <h1 style={styles.title}>MEMBRES</h1>
          <p style={styles.subtitle}>
            {filteredMembers.length} membre{filteredMembers.length > 1 ? "s" : ""}
          </p>
        </div>

        {isAdmin ? (
          <button style={styles.addButton} onClick={openAddModal}>+</button>
        ) : (
          <div style={{ width: 52 }} />
        )}
      </div>

      <div style={styles.searchBox}>
        <span style={styles.searchIcon}>⌕</span>
        <input
          style={styles.searchInput}
          placeholder="Rechercher un membre..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div style={styles.list}>
        {filteredMembers.map((member) => {
          const role = getRoleStyle(member.grade);
          const memberId = getMemberId(member);
          const isMe = String(memberId) === String(user.id);

          return (
            <div key={memberId} style={styles.card}>
              <div style={styles.cardTop}>
                <div style={styles.avatar}>{getInitials(member)}</div>

                <div style={styles.info}>
                  <h2 style={styles.name}>
                    {member.firstname} {member.lastname}
                  </h2>
                  <p style={styles.email}>{member.email}</p>
                  {member.phone && <p style={styles.phone}>{member.phone}</p>}
                  {member.fonction && (
                  <p style={styles.function}>
                           {member.fonction}
                  </p>
                )}
                </div>

                {!isMe && (
                  <div style={styles.quickActions}>
                    <button
                      style={styles.chatButton}
                      onClick={() => startConversation(member)}
                    >
                      💬
                    </button>

                    <button
                      style={styles.callButton}
                      onClick={() => startCall(member)}
                    >
                      📞
                    </button>
                  </div>
                )}
              </div>

              <div style={styles.cardBottom}>
                <span
                  style={{
                    ...styles.roleBadge,
                    color: role.color,
                    borderColor: role.border,
                    background: role.background,
                    boxShadow: role.shadow,
                  }}
                >
                  <span>{role.icon}</span>
                  {role.label}
                </span>

                {isAdmin && (
                  <div style={styles.actions}>
                    <button style={styles.editButton} onClick={() => openEditModal(member)}>
                      Modifier
                    </button>
                    {!isMe && (
                      <button style={styles.deleteButton} onClick={() => deleteMember(member)}>
                        Supprimer
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>
                {editingMember ? "Modifier" : "Ajouter"}
              </h2>
              <button style={styles.closeButton} onClick={closeModal}>×</button>
            </div>

            <input style={styles.input} placeholder="Prénom" value={form.firstname} onChange={(e) => setForm({ ...form, firstname: e.target.value })} />
            <input style={styles.input} placeholder="Nom" value={form.lastname} onChange={(e) => setForm({ ...form, lastname: e.target.value })} />
            <input style={styles.input} placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input style={styles.input} placeholder="Téléphone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />

            <input
              style={styles.input}
              type="password"
              placeholder={editingMember ? "Nouveau mot de passe optionnel" : "Mot de passe"}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />

            <select
  style={styles.input}
  value={form.role}
  onChange={(e) => setForm({ ...form, role: e.target.value })}
>
  <option value="user">Utilisateur</option>
  <option value="admin">Admin</option>
</select>

<select
  style={styles.input}
  value={form.grade}
  onChange={(e) => setForm({ ...form, grade: e.target.value })}
>
  <option value="apprenti">Apprenti</option>
  <option value="compagnon">Compagnon</option>
  <option value="maitre">Maître</option>
</select>

<select
  style={styles.input}
  value={form.fonction}
  onChange={(e) => setForm({ ...form, fonction: e.target.value })}
>
  <option value="">Aucune fonction</option>
  <option value="Vénérable Maître">Vénérable Maître</option>
  <option value="Premier Surveillant">Premier Surveillant</option>
  <option value="Second Surveillant">Second Surveillant</option>
  <option value="Orateur">Orateur</option>
  <option value="Secrétaire">Secrétaire</option>
  <option value="Trésorier">Trésorier</option>
  <option value="Hospitalier">Hospitalier</option>
  <option value="Expert">Expert</option>
  <option value="Couvreur">Couvreur</option>
</select>

            <button style={styles.saveButton} onClick={saveMember}>
              {editingMember ? "Sauvegarder" : "Ajouter"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const getInitials = (member) => {
  const first = member.firstname?.charAt(0) || "";
  const last = member.lastname?.charAt(0) || "";
  return `${first}${last}`.toUpperCase();
};

const getRoleStyle = (role) => {
  const roles = {
    admin: {
      label: "Admin",
      icon: "🛡️",
      color: "#facc15",
      border: "rgba(250,204,21,0.5)",
      background: "rgba(250,204,21,0.12)",
      shadow: "0 0 18px rgba(250,204,21,0.22)",
    },
    apprenti: {
      label: "Apprenti",
      icon: "🌿",
      color: "#22c55e",
      border: "rgba(34,197,94,0.45)",
      background: "rgba(34,197,94,0.12)",
      shadow: "0 0 18px rgba(34,197,94,0.18)",
    },
    compagnon: {
      label: "Compagnon",
      icon: "🔷",
      color: "#38bdf8",
      border: "rgba(56,189,248,0.45)",
      background: "rgba(56,189,248,0.12)",
      shadow: "0 0 18px rgba(56,189,248,0.18)",
    },
    maitre: {
      label: "Maître",
      icon: "🏛️",
      color: "#a855f7",
      border: "rgba(168,85,247,0.45)",
      background: "rgba(168,85,247,0.12)",
      shadow: "0 0 18px rgba(168,85,247,0.18)",
    },
  };

  return roles[role] || roles.apprenti;
};

const gold = "#d6b56d";

const styles = {
  page: {
    minHeight: "100vh",
    padding: "26px 18px 130px",
    background:
      "radial-gradient(circle at top, rgba(214,181,109,0.14), transparent 35%), linear-gradient(180deg, #071016 0%, #030712 100%)",
    color: "white",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 22,
  },
  backButton: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    border: "1px solid rgba(214,181,109,0.35)",
    background: "rgba(214,181,109,0.08)",
    color: gold,
    fontSize: 26,
  },
  headerCenter: {
    textAlign: "center",
  },
  title: {
    margin: 0,
    fontSize: 28,
    letterSpacing: 5,
    color: gold,
    fontFamily: "serif",
  },
  subtitle: {
    margin: "4px 0 0",
    color: "rgba(255,255,255,0.55)",
    fontSize: 15,
  },
  addButton: {
    width: 52,
    height: 52,
    borderRadius: "50%",
    border: "none",
    background: "linear-gradient(145deg, #f3d77b, #b9872f)",
    color: "#071016",
    fontSize: 34,
    fontWeight: 800,
    boxShadow: "0 0 28px rgba(214,181,109,0.45)",
  },
  searchBox: {
    height: 54,
    borderRadius: 999,
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(255,255,255,0.12)",
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    gap: 10,
    marginBottom: 18,
  },
  searchIcon: {
    color: gold,
    fontSize: 24,
  },
  searchInput: {
    flex: 1,
    background: "transparent",
    border: "none",
    outline: "none",
    color: "white",
    fontSize: 16,
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  card: {
    background: "linear-gradient(145deg, rgba(255,255,255,0.09), rgba(255,255,255,0.035))",
    border: "1px solid rgba(214,181,109,0.18)",
    borderRadius: 26,
    padding: 16,
    boxShadow: "0 18px 38px rgba(0,0,0,0.32)",
  },
  cardTop: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  avatar: {
    width: 58,
    height: 58,
    borderRadius: "50%",
    border: "1px solid rgba(214,181,109,0.55)",
    background: "radial-gradient(circle at top, rgba(214,181,109,0.55), rgba(214,181,109,0.08))",
    color: gold,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
    fontSize: 18,
    boxShadow: "0 0 22px rgba(214,181,109,0.23)",
    flexShrink: 0,
  },
  info: {
    flex: 1,
    minWidth: 0,
  },
  name: {
    margin: 0,
    fontSize: 20,
    fontWeight: 800,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  email: {
    margin: "4px 0 0",
    color: "rgba(255,255,255,0.55)",
    fontSize: 14,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  phone: {
    margin: "3px 0 0",
    color: "rgba(255,255,255,0.4)",
    fontSize: 13,
  },
  quickActions: {
    display: "flex",
    gap: 8,
    flexShrink: 0,
  },
  chatButton: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    border: "1px solid rgba(214,181,109,0.4)",
    background: "rgba(214,181,109,0.1)",
    color: gold,
    fontSize: 19,
    flexShrink: 0,
  },
  callButton: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    border: "1px solid rgba(34,197,94,0.45)",
    background: "rgba(34,197,94,0.12)",
    color: "#22c55e",
    fontSize: 19,
    flexShrink: 0,
  },
  cardBottom: {
    marginTop: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  roleBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    padding: "8px 12px",
    borderRadius: 999,
    border: "1px solid",
    fontSize: 13,
    fontWeight: 800,
  },
  actions: {
    display: "flex",
    gap: 8,
  },
  editButton: {
    border: "1px solid rgba(214,181,109,0.35)",
    background: "rgba(214,181,109,0.1)",
    color: gold,
    borderRadius: 13,
    padding: "9px 10px",
    fontWeight: 800,
  },
  deleteButton: {
    border: "1px solid rgba(248,113,113,0.35)",
    background: "rgba(248,113,113,0.1)",
    color: "#f87171",
    borderRadius: 13,
    padding: "9px 10px",
    fontWeight: 800,
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.62)",
    zIndex: 999,
    display: "flex",
    alignItems: "flex-end",
  },
  modal: {
    width: "100%",
    maxHeight: "78vh",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    background: "linear-gradient(180deg, rgba(15,23,42,0.98), rgba(7,16,22,0.98))",
    borderTop: "1px solid rgba(214,181,109,0.35)",
    borderRadius: "28px 28px 0 0",
    padding: "22px 18px 120px",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 14,
  },
  modalTitle: {
    margin: 0,
    color: gold,
    fontSize: 24,
  },
  closeButton: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.14)",
    background: "rgba(255,255,255,0.08)",
    color: "white",
    fontSize: 24,
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "15px",
    marginBottom: 11,
    borderRadius: 15,
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.08)",
    color: "white",
    fontSize: 16,
    outline: "none",
  },
  saveButton: {
    width: "100%",
    border: "none",
    borderRadius: 16,
    padding: 16,
    background: "linear-gradient(145deg, #f3d77b, #b9872f)",
    color: "#071016",
    fontSize: 17,
    fontWeight: 900,
    boxShadow: "0 0 24px rgba(214,181,109,0.3)",
  },

  function: {
  margin: "4px 0 0",
  color: "#d6b56d",
  fontSize: 13,
  fontWeight: 700,
},
};

export default Members;